import axios from 'axios'
import { backendUrl } from '../../config/config'

const getStatisticsByQuery = async (query) => {
    const result = await axios.post(`${backendUrl}/api/statistics/byQuery`, query)
    return result.data;
}

export {
    getStatisticsByQuery
}
  